import app from 'flarum/forum/app';
import Component, { ComponentAttrs } from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import Stream from 'flarum/common/utils/Stream';
import type Price from '../../common/Price';
import type Product from '../../common/Product';
import type Group from 'flarum/common/models/Group';
import type Mithril from 'mithril';

export interface IBountyOptionAttrs extends ComponentAttrs {
  price: Price;
  product: Product;
  for: Group;
  currency: string;
  amount: string | number;
}

export default class BountyOption<CustomAttrs extends IBountyOptionAttrs = IBountyOptionAttrs> extends Component<CustomAttrs> {
  private price!: Price;
  private product!: Product;
  private for!: Group;
  private currency!: string;
  private amount: Stream<number | string>;
  private loading = false;

  oninit(vnode: Mithril.Vnode<CustomAttrs, this>) {
    super.oninit(vnode);

    this.price = this.attrs.price;
    this.product = this.attrs.product;
    this.currency = this.attrs.currency;
    this.for = this.attrs.for;
    this.loading = false;
    this.amount = new Stream(this.attrs.amount === 'other' ? 250 : this.attrs.amount);
  }

  view() {
    return (
      <div className="PriceOption">
        <h2 className="group">{this.attrs.amount === 'other' ? this.customAmount() : this.currency + this.amount()}</h2>
        <div className="description">{this.description()}</div>
        <div className="controls">{this.button()}</div>
      </div>
    );
  }

  customAmount() {
    return <input bidi={this.amount} size="10" type="number" className={'FormControl'} style="background-color: var(--control-bg)" />;
  }

  description() {
    return '';
  }

  button() {
    return Button.component(
      {
        icon: 'fas fa-hand-holding-heart',
        className: 'Button hasIcon',
        onclick: this.request.bind(this),
        disabled: this.loading,
      },
      app.translator.trans('floxum-payments.forum.choose-bounty-amount-modal.checkout-control')
    );
  }

  request() {
    const handler = new Handler('bounty', {
      discussion: this.for.id(),
      amount: this.amount(),
    });

    this.loading = true;
    handler.checkout();
  }

  // @TODO: dead code?
  // @ts-ignore
  redirect(response) {
    const sessionId = response.session_id;

    // @ts-ignore
    let stripe = Stripe(app.forum.pk());

    this.loading = false;

    stripe.redirectToCheckout({ sessionId });
  }
}
